import React from "react";

export default function MySQL_COT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_COT</h1>
      <p>This is the MySQL_COT component generated from the SQL JSON.</p>
    </div>
  );
}
